import {
  createOrderForGroupBookingUsingEmailLinkMutation,
  createOrderForGroupBookingUsingEmailLinkDttMutation,
  CreateOrderForGroupBookingUsingEmailLinkResponse,
  CreateOrderForGroupBookingUsingEmailLinkDttResponse,
  ErrorResponseDtt,
} from '@marriott/mi-groups-graphql';
import { useMutationTransformer } from '../../hooks';

type createOrderForGroupBooking = {
  createOrderForGroupBookingUsingEmailLink: CreateOrderForGroupBookingUsingEmailLinkResponse;
};

type createOrderForGroupBookingDtt = {
  sales: {
    groupSales: {
      submitCreditCardEmailPayment: CreateOrderForGroupBookingUsingEmailLinkDttResponse | ErrorResponseDtt;
    };
  };
};

export const useCreateOrderForGroupBooking = () => {
  return useMutationTransformer<createOrderForGroupBooking, createOrderForGroupBookingDtt>({
    currentMutation: createOrderForGroupBookingUsingEmailLinkMutation,
    dttMutation: createOrderForGroupBookingUsingEmailLinkDttMutation,
    onTransform: data => {
      const { basicInformation, property } = data.createOrderForGroupBookingUsingEmailLink;
      return {
        sales: {
          groupSales: {
            submitCreditCardEmailPayment: {
              basicInformation: {
                externalIdInfo: [
                  {
                    id: basicInformation.opportunityID,
                  },
                ],
              },
              confirmationNumber: '',
              property: {
                basicInformation: property.basicInformation,
                contactInformation: {
                  address: property.address,
                },
              },
            },
          },
        },
      };
    },
  });
};
